export default __webpack_public_path__ + "static/media/2.b58ea1c9.png";